import React, { useState } from 'react';
import { Calendar as CalendarIcon, X } from 'lucide-react';
import { Button } from './Button';
interface ChangeTargetDateModalProps {
  title?: string;
  helperText?: string;
  onConfirm: (date: string) => void;
  onCancel: () => void;
}
export function ChangeTargetDateModal({
  title = 'Select a new target date',
  helperText = 'This workout can be moved to any date, even if it falls outside your usual training schedule.',
  onConfirm,
  onCancel
}: ChangeTargetDateModalProps) {
  const [selectedDate, setSelectedDate] = useState<string>('');
  const today = new Date().toISOString().split('T')[0];
  return <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-end sm:items-center justify-center p-4 animate-in fade-in duration-200" data-id="element-70">
      <div className="bg-white w-full max-w-sm rounded-[2.5rem] p-6 shadow-2xl animate-in slide-in-from-bottom-8 sm:zoom-in-95 duration-300 relative" data-id="element-71">
        <button onClick={onCancel} className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors" data-id="element-72">
          <X size={20} data-id="element-73" />
        </button>

        <div className="w-12 h-12 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mb-6 mx-auto" data-id="element-74">
          <CalendarIcon size={24} data-id="element-75" />
        </div>

        <div className="text-center mb-6" data-id="element-76">
          <h2 className="text-2xl font-extrabold text-slate-800 mb-2" data-id="element-77">
            {title}
          </h2>
          <p className="text-slate-500 font-medium text-sm leading-relaxed" data-id="element-78">
            {helperText}
          </p>
        </div>

        <div className="bg-stone-50 p-4 rounded-2xl border border-stone-100 mb-8" data-id="element-79">
          <label className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-2 block" data-id="element-80">
            Select Date
          </label>
          <input type="date" min={today} value={selectedDate} onChange={e => setSelectedDate(e.target.value)} className="w-full bg-white border-2 border-slate-200 focus:border-emerald-400 hover:border-slate-300 rounded-xl py-3 px-4 text-slate-800 font-bold focus:outline-none transition-colors" data-id="element-81" />
        </div>

        <div className="space-y-3" data-id="element-82">
          <Button variant="primary" fullWidth onClick={() => onConfirm(selectedDate)} disabled={!selectedDate} data-id="element-83">
            Confirm new target date
          </Button>
          <Button variant="ghost" fullWidth onClick={onCancel} data-id="element-84">
            Cancel
          </Button>
        </div>
      </div>
    </div>;
}